module.exports = __webpack_public_path__ + "static/media/back-6.8ec08ce7.svg";